import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function MainLayout({ children }) {
  return (
    <div className="min-h-full bg-gradient-to-b from-white via-slate-50 to-white text-slate-900">
      <Header />
      <main id="content">{children}</main>
      <Footer />
    </div>
  );
}
